module.exports = __webpack_public_path__ + "img/my-community.8f0df7f1.png";